import { getRgObjectsOfType as l, RG_TYPE as s } from "@project-rouge/rg-core";
import { getLevelCount as u } from "../object-helpers/index3.js";
function g(t, o) {
  const r = [], n = l(t, s.Building), i = u(n, !1);
  for (let e = 0; e < i; e++)
    r.push(o(t, e));
  return r;
}
export {
  g as getLevelArrayMetric
};
//# sourceMappingURL=index4.js.map
